import { createFileRoute } from '@tanstack/react-router';

import {
  loadSimulationMessages,
  loadSimulationVehicleHubScreen,
  simulationVehicleScreen,
} from '@/modules/simulation/route';
import { lazyScreen } from '@/shared/screen/lazy-screen';

// Veículo no caminho do legado (`router.tsx:1085-1093`, só com `ENABLE_NEW_SIMULATION === 1`): a flag e a permissão
// vão no manifesto. Arquivo leve (JS inicial); a tela vem em chunk próprio.
export const Route = createFileRoute('/_app/ccb/contratar/veiculo/')({
  staticData: { screen: simulationVehicleScreen },
  loader: () => loadSimulationMessages(),
  component: lazyScreen(loadSimulationVehicleHubScreen, 'VehicleHubRouteScreen'),
});
